var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterCodeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 410,
    viewBox: "0 0 212 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 205,
    cy: 205,
    r: 203.5,
    fill: "white",
    fillOpacity: 0.2,
    stroke: "white",
    strokeWidth: 3,
    strokeDasharray: "12 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterCodeCircle);
export default __webpack_public_path__ + "static/media/enter-code-circle.5111c46f50ba6a6f697ba98b4809100a.svg";
export { ForwardRef as ReactComponent };